import type { EntityRegistry } from '@sites/entity-migrator';

import {
    DefaultBlockEntitySchema,
    SpecificBlockEntitySchema,
    ZeroBlockEntitySchema,
    type BlockEntity,
} from './schemas';

export const blockRegistry: EntityRegistry<BlockEntity> = {
    name: 'block',
    getEntitySchema: (entity: unknown) => {
        if (typeof entity !== 'object' || entity === null) return null;

        const { entitySubType, version, type } = entity as {
            entitySubType?: unknown;
            version?: unknown;
            type?: unknown;
        };

        if (entitySubType === 'default') return DefaultBlockEntitySchema;
        if (entitySubType === 'specific') return SpecificBlockEntitySchema;
        if (entitySubType === 'zero') return ZeroBlockEntitySchema;

        // Pre-versioning blocks carry neither subtype nor version, but unlike
        // sections and columns they do tag themselves — the legacy `type` field
        // names all three kinds.
        if (entitySubType === undefined && version === undefined) {
            if (type === 'specific') return SpecificBlockEntitySchema;
            if (type === 'zero') return ZeroBlockEntitySchema;

            // `DEFAULT` or nothing at all — the oldest blocks predate the tag.
            return DefaultBlockEntitySchema;
        }

        return null;
    },
};
